import { normalizeWhatsappNumber } from "../dealerWhatsapp";
import {
  AUTOMAP_WHATSAPP_INTAKE_SOURCE,
  resolveAutomapWhatsappEntryPoint,
} from "./automapWhatsappIntakeConstants";

function parseOptionalAmount(value) {
  if (value == null || value === "") return null;
  const cleaned = String(value).replace(/[^\d]/g, "");
  if (!cleaned) return null;
  const amount = Number(cleaned);
  return Number.isFinite(amount) ? amount : null;
}

/**
 * Build the normalized intake payload for M4 submission.
 * M3 only constructs this locally — no network calls.
 */
export function buildAutomapWhatsappIntakePayload({
  form,
  vehicleContext = null,
  widgetContext = null,
  createdAt = null,
} = {}) {
  const interestedRaw = String(form?.financingInterest || "").trim();
  const interested = ["yes", "no", "unsure"].includes(interestedRaw) ? interestedRaw : "";
  const includeFinancingDetails = interested === "yes" || interested === "unsure";
  const entryPoint = resolveAutomapWhatsappEntryPoint(widgetContext);

  return {
    source: AUTOMAP_WHATSAPP_INTAKE_SOURCE,
    entryPoint,
    buyer: {
      name: String(form?.buyerName || "").trim(),
      whatsapp: normalizeWhatsappNumber(form?.buyerWhatsapp || ""),
      email: String(form?.buyerEmail || "").trim() || null,
    },
    financing: {
      interested: interested || null,
      downPaymentAmount: includeFinancingDetails
        ? parseOptionalAmount(form?.downPaymentAmount)
        : null,
      downPaymentCurrency: form?.downPaymentCurrency || "COP",
      preferredLoanTermMonths: includeFinancingDetails
        ? form?.preferredLoanTermMonths
          ? Number(form.preferredLoanTermMonths)
          : null
        : null,
    },
    vehicle: vehicleContext
      ? {
          id: vehicleContext.listingId || null,
          make: vehicleContext.make || null,
          model: vehicleContext.model || null,
          year: vehicleContext.year || null,
          trim: vehicleContext.trim || null,
          price: vehicleContext.priceCop ?? vehicleContext.priceLabel ?? null,
          currency: vehicleContext.currency || "COP",
          mileageKm: vehicleContext.mileageKm ?? null,
          listingUrl: vehicleContext.listingUrl || vehicleContext.listingPath || null,
          imageUrl: vehicleContext.imageUrl || null,
          city: vehicleContext.city || null,
          dealerId: vehicleContext.dealerId || null,
          dealerName: vehicleContext.dealerName || null,
        }
      : null,
    notes: String(form?.buyerNotes || "").trim() || null,
    createdAt: createdAt || new Date().toISOString(),
  };
}
